/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_SoreInputs */

const en_us2_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sore`)
};

const pt_br2_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dolorido`)
};

const es_419_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adolorido`)
};

const pt_pt2_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dorido`)
};

const fr_fr2_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`courbaturé`)
};

const de_de2_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskelkater`)
};

const it_it2_recovery_sore = /** @type {(inputs: Recovery_SoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`indolenzito`)
};

/**
* | output |
* | --- |
* | "sore" |
*
* @param {Recovery_SoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_sore = /** @type {((inputs?: Recovery_SoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_SoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_sore(inputs)
	if (locale === "es-419") return es_419_recovery_sore(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_sore(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_sore(inputs)
	if (locale === "de-DE") return de_de2_recovery_sore(inputs)
	if (locale === "it-IT") return it_it2_recovery_sore(inputs)
	return en_us2_recovery_sore(inputs)
});
export { recovery_sore as "recovery.sore" }